import { RefObject, useLayoutEffect, useState } from 'react';

export default function useIsTruncated(
    ref: RefObject<HTMLElement>,
    watch?: unknown,
): boolean {
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;

        const measure = () => {
            const yOverflow = el.scrollHeight > el.clientHeight + 1;
            const xOverflow = el.scrollWidth > el.clientWidth + 1;
            setIsTruncated(yOverflow || xOverflow);
        };

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return () => ro.disconnect();
    }, [ref, watch]);

    return isTruncated;
}
